import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api, getTicketTypesByEventId, getTicketTypeInfosByTicketTypeId, getTicketTypeNumberOfAvailableTickets } from "ticketino-api-client";

import Header from "./components/Header";

import { ReactComponent as IconAlert } from '../images/icon/icon-alert.svg';

const SponsorSpeaker_Step10_Tickets = () => {
    const [order, setOrder] = useState({});
    const [orderId, setOrderId] = useState();
    const [organizerId, setOrganizerId] = useState(0);

    const [eventId, setEventId] = useState(0);
    const [ticketTypeId, setTicketTypeId] = useState(0);
    const [ticketTypes, setTicketTypes] = useState([]);
    const [selectedTicketTypes, setSelectedTicketTypes] = useState([]);

    const [unlockedTicketTypes, setUnlockedTicketTypes] = useState([]);

    const [promotioncode, setPromotioncode] = useState("");
    const [promotioncodeAdded, setPromotioncodeAdded] = useState("");
    const [promotionError, setPromotionError] = useState("");
    const [promotionSuccess, setPromotionSuccess] = useState("");

    const [isAgbChecked, setIsAgbChecked] = useState(false);

    const [disabled, setDisabled] = useState(true);

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // setting the base url of the npm package api calls
    api.defaults.baseURL = baseUrl;

    // fetching resources
    const [resources, setResources] = useState({});

    // fetching params
    let { language } = useParams();

    let languageId = 0;

    // changing languageId according to the url
    switch (language) {
        case ("de" || "DE"):
            languageId = 1;
            break;
        case ("fr" || "FR"):
            languageId = 2;
            break;
        default:
            languageId = 0;
            language = "de";
            break;
    }

    useEffect(() => {
        const loadToken = async () => {
            try {
                const res = await axios.get("form/token");
                axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;
                api.defaults.headers.common['Authorization'] = "Bearer " + res.data;
                await sessionStorage.setItem("token", res.data);

                requestFormSettings();
            } catch (error) {
                console.error(error);
            }
        };

        let currentOrderId = sessionStorage.getItem("orderId");

        if (currentOrderId > 0) {
            setOrderId(currentOrderId);
        }

        const requestFormSettings = async () => {
            try {
                const res = await axios.get(`form/formsettings`);

                if (currentOrderId > 0) {
                    loadOrder(currentOrderId);
                } else {
                    sessionStorage.removeItem("addedPromotion"); // clear promotion code
                    navigate("/de/sponsor-speaker/home");
                }

                setOrganizerId(res.data.organizerId)
                setEventId(res.data.eventId)
                setTicketTypeId(res.data.ticketTypeSponserSpeakerId);

            } catch (error) {
                console.error(error);
            }
        };

        loadToken();
    }, []);

    useEffect(() => {
        if (orderId && eventId) {
            loadTicketTypes(eventId)
        }
    }, [orderId, eventId]);

    useEffect(() => {
        requestResources();
    }, [language]); //everytime language is changed

    const requestResources = async () => {
        await axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data?.translation);
            })
            .catch((error) => console.error(error.response.data));
    };

    const getOrderByOrderId = async (orderId) => {
        try {
            const res = await axios.get(`${baseUrl}/ShopBasket/Order/${orderId}`);
            return res.data;
        }
        catch (error) {
            console.error(error);
            if (error.response.status === 404 || error.response.status === 403) {
                navigate("/de/sponsor-speaker/home");
            }
        }
    }

    const getTicketTypeAvailability = async (ticketTypeId, orderId, promotionCode) => {
        try {
            const response = await axios.get(`${baseUrl}/TicketType/${ticketTypeId}/Availability?orderId=${orderId}&promotionCode=${promotionCode}`);
            return response.data;
        } catch (error) {
            console.error(error.response.data);
            setPromotionError(resources.detailPage?.errorMessage);
        }
    }

    const loadOrder = async (orderId) => {
        try {
            // Order
            const updatedOrder = await getOrderByOrderId(orderId);

            if (updatedOrder === null) {
                navigate("/de/sponsor-speaker/home")
            }

            setOrder(updatedOrder);

            // Remove tickets from order if any exist
            if (updatedOrder && Array.isArray(updatedOrder.tickets) && updatedOrder.tickets.length > 0) {
                const ticketsToRemove = updatedOrder.tickets.map(t => t.id);

                if (ticketsToRemove.length > 0) {
                    await deleteTicketsFromBasket(orderId, ticketsToRemove);
                    // Optionally reload order after deletion
                    const refreshedOrder = await getOrderByOrderId(orderId);
                    setOrder(refreshedOrder);
                }
            }
        }
        catch (error) {
            console.error(error);
        }
    }

    const loadTicketTypes = async (eventId) => {
        try {
            const ticketTypes = await getTicketTypesByEventId(eventId);
            // Filter ticketTypes to only include the one with id === ticketTypeId
            const filteredTicketTypes = ticketTypes.filter(tt => tt.id === ticketTypeId);

            const updatedTicketTypes = await Promise.all(
                filteredTicketTypes.map(async (ticketType) => {
                    const info = await getTicketTypeInfosByTicketTypeId(ticketType.id);

                    // sorting it according to the language
                    const ticketTypeInfo = info.find(info => info.languageId == languageId) ?? info[0];

                    const ticketTypeAvailability = await getTicketTypeNumberOfAvailableTickets(ticketType.id, orderId);

                    // setting the ticketTypeInfo and ticketTypeAvailability object as attributes in ticketType (info and availability)
                    return { ...ticketType, info: ticketTypeInfo, availability: ticketTypeAvailability }
                })
            )

            setTicketTypes(updatedTicketTypes);
        } catch (error) {
            console.error(error);
        }
    }

    const addPromotionToOrder = async () => {
        setPromotionError("");
        setPromotionSuccess("");

        const updatedUnlockedTicketTypes = await applyPromotionCodeToOrder(orderId, promotioncode);
        let updatedTicketTypes = [];

        updatedTicketTypes = await Promise.all(ticketTypes.map(async (ticketType) => {
            if (updatedUnlockedTicketTypes?.unlockedTicketTypes?.includes(ticketType.id)) {
                const unlockedTicketTypeAvailability = await getTicketTypeAvailability(ticketType.id, orderId, promotioncode);
                ticketType.availability = unlockedTicketTypeAvailability;
            }
            return ticketType;
        }))

        sessionStorage.setItem("addedPromotion", promotioncode);
        setPromotioncodeAdded(promotioncode);

        setTicketTypes(updatedTicketTypes)
        setUnlockedTicketTypes(updatedUnlockedTicketTypes?.unlockedTicketTypes ?? []);
        if (updatedUnlockedTicketTypes && !updatedUnlockedTicketTypes.error) {
            setPromotionSuccess(resources?.PromocodeSuccess);
        }
    }

    const applyPromotionCodeToOrder = async (orderId, code) => {
        try {
            const response = await axios.put(`${baseUrl}/ShopBasket/Order/${orderId}/PromotionCode/${code}`);
            return response.data;
        } catch (error) {
            console.error(error.response.data);
            setPromotionError(resources?.PromotionError);
            setPromotionSuccess("");
        }
    }

    const deleteTicketsFromBasket = async (orderId, ticketIds) => {
        if (!orderId) return; // Prevent API call if orderId is not set
        try {
            const response = await axios.delete(`${baseUrl}/ShopBasket/Order/${orderId}/Tickets`, { headers: { Accept: "application/json" }, data: { "TicketsToRemove": ticketIds } });
            return response.data;
        } catch (error) {
            console.error(error);
        }
    }

    const onSubmit = async () => {
        await addTicketToBasket();
    }

    const addTicketToBasket = async () => {
        // Loop through selectedTicketTypes and add each with its quantity
        const addTicketTypes = selectedTicketTypes
            .filter(t => t.quantity > 0)
            .map(t => ({ ticketTypeId: t.ticketTypeId, quantity: t.quantity, promotionCode: promotioncodeAdded }));

        // If no tickets selected, do not proceed
        if (addTicketTypes.length === 0) return;

        return axios
            .post(`${baseUrl}/ShopBasket/Order/${orderId}/Tickets`, {
                ticketsToAdd: addTicketTypes,
            })
            .then(() => {
                //// gtm - addToCart
                //window.dataLayer = window.dataLayer || [];
                //window.dataLayer.push({
                //    'event': 'addToCart'
                //});

                navigate(`/${language}/sponsor-speaker/address`);
            })
            .catch((error) => {
                console.error(error.response?.data || error);
                loadOrder(orderId);
            });
    };

    const onQuantityChange = (ticketTypeId, delta, max) => {
        setSelectedTicketTypes(prev => {
            const existing = prev.find(t => t.ticketTypeId === ticketTypeId);
            let quantity = existing ? parseInt(existing.quantity) : 0;
            quantity += delta;
            if (quantity < 0) quantity = 0;
            if (quantity > max) quantity = max;
            const updated = prev.filter(t => t.ticketTypeId !== ticketTypeId);
            if (quantity > 0) {
                updated.push({ ticketTypeId, quantity });
            }
            // Remove setDisabled here; useEffect will handle it
            return updated;
        });
    };

    const getQuantity = (ticketTypeId) => {
        const found = selectedTicketTypes.find(t => t.ticketTypeId === ticketTypeId);
        return found ? found.quantity : 0;
    };

    const mapTicketTypes = () => {
        let ticketTypesSorted = [];

        if (ticketTypes && ticketTypes.length > 0) {
            ticketTypesSorted = [...ticketTypes].sort((a, b) => a.sortOrder - b.sortOrder);
        }

        return (
            ticketTypes &&
            ticketTypes.length > 0 &&
            ticketTypesSorted.map((tt, index) => (
                <div key={index}>
                    <div>
                        <div className="row pt-2 pb-1">
                            <div className="col-md-5 col-4">
                                <label style={tt.availability?.status !== 0 ? { color: 'grey' } : {}}>{tt.info?.name}</label>
                            </div>
                            <div className="col-md-2 col-4 text-end">
                                <label style={tt.availability?.status !== 0 ? { color: 'grey' } : {}}>{tt.currency} {tt.price.toFixed(2)}</label>
                            </div>
                            <div className="col-md-2 col-4 text-end">
                                <div style={{ display: 'inline-flex', alignItems: 'center', marginLeft: '10px' }}>
                                    <button
                                        type="button"
                                        className="btn btn-secondary btn-sm"
                                        style={{ minWidth: '32px', backgroundColor: '#3793c4', borderColor: '#3793c4', boxShadow: 'none', outline: 'none' }}
                                        onClick={() => onQuantityChange(tt.id, -1, tt.availability?.availableTickets)}
                                        disabled={tt.availability?.status !== 0}
                                    >
                                        -
                                    </button>
                                    <span style={{ margin: '0 10px', minWidth: '20px', textAlign: 'center', color: tt.availability?.status !== 0 ? 'grey' : undefined }}>{getQuantity(tt.id)}</span>
                                    <button
                                        type="button"
                                        className="btn btn-secondary btn-sm"
                                        style={{ minWidth: '32px', backgroundColor: '#3793c4', borderColor: '#3793c4', boxShadow: 'none', outline: 'none' }}
                                        onClick={() => onQuantityChange(tt.id, 1, tt.availability?.availableTickets)}
                                        disabled={tt.availability?.status !== 0}
                                    >
                                        +
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))
        );
    };

    useEffect(() => {
        // Button is enabled only if at least one ticket is selected AND both terms are checked
        const total = selectedTicketTypes.reduce((sum, t) => sum + t.quantity, 0);
        setDisabled(!(total > 0 && isAgbChecked));
    }, [selectedTicketTypes, isAgbChecked]);

    return (
        <div className="page-container">
            <Header language={language} />
            <div className="container wrapper-small">

                <div className="row mt-2">
                    <div className="col-md-12">
                        <span className="text-title d-block">{resources?.EventName}</span>
                        <span className="text-subtitle d-block">{resources?.SpeakerSponsorHomeTitle}</span>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-md-12">
                        {mapTicketTypes()}
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <span className="text-secondary"><i>{resources?.SponsorSpekarOnlyWithPromocode}</i></span>
                    </div>
                </div>

                {/* promocode */}
                <div className="row mt-4 mb-2">
                    <div className="col-md-12">
                        {resources?.Promocode}
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6 col-8">
                        <input
                            id="inputCode"
                            type="text"
                            name="promotionCode"
                            className="form-control"
                            value={promotioncode}
                            onChange={(e) => { setPromotioncode(e.target.value); setPromotionSuccess(""); setPromotionError(""); }}
                        />
                    </div>
                    <div className="col-md-4 col-4">
                        <button
                            style={{ height: "35px" }}
                            className="btn button-custom mt-1"
                            onClick={addPromotionToOrder}
                            disabled={promotioncode === ""}
                        >
                            {resources?.PromotionRedeem}
                        </button>
                    </div>
                </div>

                {promotionError && (
                    <div className="alert error mt-4" role="alert" style={{ display: 'flex', alignItems: 'center' }}>
                        <IconAlert style={{ fill: 'white', marginRight: '8px', flexShrink: 0 }} />
                        <span>{promotionError}</span>
                    </div>
                )}
                {promotionSuccess && (
                    <div className="alert success mt-4" role="alert" style={{ display: 'flex', alignItems: 'center', background: '#d4edda', color: '#155724' }}>
                        <IconAlert style={{ fill: 'white', marginRight: '8px', flexShrink: 0 }} />
                        <span>{promotionSuccess}</span>
                    </div>
                )}

                <div className="row mt-5">

                    <div className="col-md-12 mb-3">

                        {/* Terms and conditions */}
                        <div className="font-14px mt-3" style={{ display: 'flex', alignItems: 'flex-start' }}>
                            <span onClick={() => setIsAgbChecked(!isAgbChecked)} style={{ cursor: 'pointer', marginTop: 3 }}>
                                {isAgbChecked ? (
                                    <i className="bi bi-check-square me-2"></i>
                                ) : (
                                    <i className="bi bi-square me-2"></i>
                                )}
                            </span>
                            <input
                                className="form-check-input d-none"
                                type="checkbox"
                                id="agb2Checkbox"
                                checked={isAgbChecked}
                                onChange={() => setIsAgbChecked(!isAgbChecked)}
                            />
                            <label
                                className="d-inline ms-2"
                                htmlFor="agb2Checkbox"
                                style={{ cursor: 'pointer', marginBottom: 0 }}
                            >
                                <span dangerouslySetInnerHTML={{ __html: resources?.SponsorSpeakerAgb }}></span>
                            </label>
                        </div>
                    </div>

                    <div className="row mt-4">
                        <div className="col-md-6">
                            <button className="btn button-custom" onClick={() => navigate(-1)}>{resources?.Back}</button>
                        </div>
                        <div className="col-md-6 text-end">
                            <button className="btn button-custom" onClick={() => onSubmit()} disabled={disabled}>{resources?.Next}</button>
                        </div>
                    </div>

                    <p className="mt-4">
                        <small style={{ color: 'grey', fontSize: '10px' }}>powered by <a style={{ color: 'grey', textDecoration: 'none' }} href="https://organizer.ticketino.com/de" target="_blank">TICKETINO</a></small>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default SponsorSpeaker_Step10_Tickets